import React from 'react'
import './viewTaskReason.css'
import CloseIcon from '@mui/icons-material/Close';

interface ViewTaskReasonProps {
    reason: any
    onClose: () => void
}

const ViewTaskReason = (props: ViewTaskReasonProps) => {

    return (
        <div className='view-task-reason-container'>
            <div className="modal-heading">
                <h4>Reason</h4>
                <CloseIcon
                    className='modal-close-button'
                    onClick={props.onClose}
                />
            </div>
            <div className="modal-body">
                {props.reason}
            </div>

        </div>

    )
}

export default ViewTaskReason